import './impositionView.scss';

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const padLeft = require('lodash/string/padLeft');
const Immutable = require('immutable');
// @ actions
const liquidationsActions = require('actions/liquidations');
const movementsActions = require('actions/movements');
const depositsActions = require('actions/deposits');
const morningStarActions = require('actions/morningStar');
import offersActions from 'actions/offersActions';
import contractsActions from 'actions/contracts';
// @ commons
const { formatText, FormattedText, getLanguage, getFinalTitle } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
// @ helpers
const {
    getAccountByImposition,
    getFundsByImposition
} = require('utilities/currentAccountsHelper.js');
const { getLastNChars } = require('utilities/stringHelper');
const {
    findFundByContractNumber,
    getFundDataForImposition,
    getFundId
} = require('utilities/investmentFundsHelper');
const {
    getImpositionStatus,
    impositionTextKeyfromStatus,
    IMPOSITION_STATUS_EXPIRED
} = require('utilities/contactCenter/impositionsHelper');
import { scrollToTop } from 'commonsUtilities/scrollUtils';
// @ components
const ImpositionDetailBox = require('components/imposition/impositionDetailBox/impositionDetailBox');
const ImpositionSidebar = require('components/imposition/impositionSidebar/impositionSidebar');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const Liquidation = require('components/imposition/liquidation/liquidation');
const Movements = require('components/imposition/movements/movements');
const Investment = require('components/imposition/investment/investment');
const { CommercialAdsCCValidated : CommercialAds } = require('components/commons/commercialAds/commercialAds');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
import DepositOfferSection from 'components/depositOfferSection/depositOfferSection';
import { OfferExamples } from '../../components/offersExample/offersExample';

class ImpositionView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleRequestToHideOfferPost = this.handleRequestToHideOfferPost.bind(this);
        this.state = { detailRequested: false, examples: []};
    }

    componentDidMount() {
        scrollToTop();
    }

    componentWillMount() {
        if (!this.props.immDeposits.get('byId')) {
            this.props.requestDeposits();
        } else {
            this.getDataFromServices(this.props, this.state);
        }
    }

    handleRequestToHideOfferPost = (depositContractAndImpositionList) => {
        const { requestHideDepositOfferPost } = this.props
        requestHideDepositOfferPost(depositContractAndImpositionList)
    }

    componentWillUpdate(nextProps, nextState) {
        this.getDataFromServices(nextProps, nextState);
    }

    componentWillUnmount() {
        this.props.resetLiquidationsFailure()
    }

    getDataFromServices(props, state) {
        const { match: { params: { depositId, impositionId } }, immDeposits, immAccounts } = props;

        if (
            !immDeposits.get('isFetching') &&
            !immAccounts.get('isFetching') &&
            !state.detailRequested
        ) {
            this.setState({ detailRequested: true });
            this.props.requestLiquidations(depositId, impositionId);
            this.props.requestLiquidationPeriods(depositId, impositionId);
            this.props.requestMovements(depositId, impositionId);
            this.props.requestInterveners(depositId);
        }
    }

    handleDataFromHook = (data) => {
        this.setState({ examples: data });
    }

    goToDepositsCallback = (depositIdentify, depositId) => {
        const { setRenewalDepositId, setRenewalOrTransferToken } = this.props;
        setRenewalOrTransferToken(depositIdentify);
        setRenewalDepositId(depositId)
    }

    getFullContractNumber() {
        const { match: { params: { depositId } }, immSavings } = this.props;
        const immSaving = immSavings.filter(immSaving => immSaving.get('id') === depositId).first();

        return immSaving.get('fullContractNumber');
    }

    isClosed() {
        const { match: { params: { depositId } }, immDeposits } = this.props;
        const deposits = immDeposits.get('byId');
        let isClosed = false;
        if (depositId && deposits) {
            isClosed = deposits.getIn([depositId, 'isClosed']);
        }

        return isClosed;
    }
    render() {
        const {
            match: { params: { depositId, impositionId } },
            flagBasedFeatures,
            history,
            immDeposits,
            immMovements,
            immLiquidations,
            immAccounts,
            immMorningStarInvestmentData,
            immOffers,
            immProfile,
            originCountry,
            requestOffers,
            resetHideDepositOfferPost,
        } = this.props;
        const immDeposit = immDeposits.getIn(['byId', depositId]);
        if (immDeposit && !immDeposit.get('isFetching')) {
            const fullContractNumber = this.getFullContractNumber();
            const immImposition = immDeposit.getIn(['impositionList', 'byId', impositionId]);
            const immImpositionAssociatedAccount = immDeposit.get('impositionAssociatedAccount');
            const immAccount = getAccountByImposition(immImpositionAssociatedAccount, immAccounts);
            const immInterveners = immDeposit.getIn(['interveners', 'list']) || Immutable.fromJS([]);
            const immImpositions = immDeposit.get('impositionList');
            const fundsAmountTotal = getFundsByImposition(immImpositions);
            const hideOfferPostState = immDeposits.get('hideOfferPost').toJS()
            let alias = '';
            let iban = '';
            let isFetchingInterveners = false;

            if (!!immAccount) {
                alias = immAccount.get('alias');
                iban = immAccount.get('iban');
                isFetchingInterveners = immAccount.getIn(['interveners', 'isLoading']);
            }
            const account = alias + ' ' + getLastNChars(iban);
            const isContratation =
                immImposition.get('activationDate') === immImposition.get('lastRenewal');
            let isExpired = new Date(immImposition.get('expirationDate')) < new Date();
            let status = `impositionRow-${isExpired ? 'expired' : 'valid'}`;
            let investmentSection;
            let fundData;

            const currentServiceDate = immDeposits.get('actualDate');
            const impositionStatus = getImpositionStatus(immImposition, currentServiceDate);
            if (__CONTACT_CENTER__) {
                status = impositionTextKeyfromStatus(impositionStatus);
                isExpired = impositionStatus === IMPOSITION_STATUS_EXPIRED;
            }


            const amountHeader = {
                amount: immImposition.get('amount'),
                currency: immImposition.get('currency')
            };
            const plainAmountObject = getPlainAmountObject(amountHeader);

            if (fundsAmountTotal.amount > 0) {
                const investmentFund = findFundByContractNumber(this.props.immInvestmentFunds, immImposition.get('fundContract'));
                fundData = getFundDataForImposition(investmentFund);
                investmentSection = (
                    <Investment
                        depositId={depositId}
                        immImposition={immImposition}
                        getMorningStarInvestmentData={this.props.getMorningStarInvestmentData}
                        immMovements={immMovements}
                        immMorningStarInvestmentData={immMorningStarInvestmentData}
                        fundId={getFundId(investmentFund)}
                    />
                );
            }

            let liquidationsEmpty = !!immLiquidations.get('byId') && immLiquidations.get('byOrder').size;
            let liquidationContent, liquidationContentEmpty;

            // Move liquidations content to bottom if liquidations are empty.
            if (liquidationsEmpty) {
                liquidationContent = <Liquidation immLiquidations={immLiquidations} immImposition={immImposition} />;
            } else {
                liquidationContentEmpty = <Liquidation immLiquidations={immLiquidations} immImposition={immImposition} />;
            }

            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-deposits'),
                    url: '/myprofile/deposits'
                },
                {
                    text: formatText('breadcrumb-impositionDetail'),
                    url: ''
                }
            ];

            return (
                <section className="imposition-view">
                    <OKCover size="medium" section="deposits" customClass="imposition-view__deposits">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            finalTitle={getFinalTitle('imposition-headerTitle', [padLeft(parseInt(impositionId), 3, '0')])}
                        >
                            <div className="imposition-view__right-header">
                                <div className="imposition-view__right-header--label">
                                    <FormattedText value="imposition-amount" />
                                </div>
                                <OneLineSymbolAmount
                                    className="imposition-view__right-header--amount"
                                    amountObject={plainAmountObject}
                                    language={getLanguage()}
                                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                />
                            </div>
                        </OKHeaderSubPage>
                    </OKCover>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">
                                <div className="col-xs-8">
                                    <WebappRender>
                                        <ImpositionDetailBox
                                            isClosed={this.isClosed()}
                                            firstPeriod={isContratation}
                                            lastRenewal={immImposition.get('lastRenewal')}
                                            expireDate={immImposition.get('expirationDate')}
                                            tae={immImposition.get('tae')}
                                            tin={immImposition.get('tin')}
                                            originCountry={originCountry}
                                            renewal={immImposition.get('renewal')}
                                            status={status}
                                        />
                                    </WebappRender>
                                    <ContactCenterRender>
                                        <ImpositionDetailBox
                                            isClosed={this.isClosed()}
                                            depositId={depositId}
                                            impositionId={impositionId}
                                            firstPeriod={isContratation}
                                            lastRenewal={immImposition.get('lastRenewal')}
                                            expireDate={immImposition.get('expirationDate')}
                                            tae={immImposition.get('tae')}
                                            tin={immImposition.get('tin')}
                                            originCountry={originCountry}
                                            renewal={immImposition.get('renewal')}
                                            status={status}
                                            impositionStatus={impositionStatus}
                                        />
                                    </ContactCenterRender>
                                    {liquidationContent}
                                    <section className='imposition-view__main-section'>
                                        <Movements immMovements={immMovements} />
                                        <div>
                                            <DepositOfferSection
                                                depositId={depositId}
                                                history={history}
                                                flagBasedFeatures={flagBasedFeatures}
                                                onDataReceived={this.handleDataFromHook}
                                                goToDepositsCallback={this.goToDepositsCallback}
                                                immDeposits={immDeposits}
                                                immProfile={immProfile}
                                                originCountry={originCountry}
                                                immOffers={immOffers}
                                                requestOffers={requestOffers}
                                                onHideOfferPost={this.handleRequestToHideOfferPost}
                                                hideOfferPostState={hideOfferPostState}
                                                resetHideDepositOfferPost={resetHideDepositOfferPost}
                                            />
                                        </div>
                                    </section>
                                    {investmentSection}
                                    {liquidationContentEmpty}
                                    <OfferExamples originCountry={originCountry} examples={this.state.examples} />
                                </div>
                                <div className="col-xs-4">
                                    <WebappRender>
                                        <ImpositionSidebar
                                            title={immDeposit.get('description')}
                                            amountObject={immDeposit.get('amount')}
                                            contractNumber={fullContractNumber}
                                            account={account}
                                            isFetchingInterveners={isFetchingInterveners}
                                            immInterveners={immInterveners}
                                            fund={fundData}
                                        />
                                    </WebappRender>
                                    <ContactCenterRender>
                                        <ImpositionSidebar
                                            title={immDeposit.get('description')}
                                            amountObject={immDeposit.get('amount')}
                                            contractNumber={fullContractNumber}
                                            account={account}
                                            isFetchingInterveners={isFetchingInterveners}
                                            immInterveners={immInterveners}
                                            fund={fundData}
                                            immDeposits={immDeposits}
                                            depositId={depositId}
                                            impositionId={impositionId}
                                            showImpositionCCActions={true}
                                        />
                                    </ContactCenterRender>
                                    <div className="imposition-view__commercial-ads">
                                        <CommercialAds
                                            path="deposits/:depositId/imposition/:impositionId"
                                            type="banner-a"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        } else {
            return <section className="imposition-view" />;
        }
    }
}

ImpositionView.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    getMorningStarInvestmentData: PropTypes.func,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immDeposits: PropTypes.object.isRequired,
    immInvestmentFunds: PropTypes.object.isRequired,
    immLiquidations: PropTypes.object.isRequired,
    immMorningStarInvestmentData: PropTypes.object,
    immMovements: PropTypes.object.isRequired,
    immSavings: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
    requestLiquidations: PropTypes.func.isRequired,
    resetLiquidationsFailure: PropTypes.func.isRequired,
    requestLiquidationPeriods: PropTypes.func.isRequired,
    requestMovements: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestDeposits: PropTypes.func.isRequired,
};

module.exports.constructor = ImpositionView;
module.exports.ImpositionView = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immDeposits: state.deposits,
        immInvestmentFunds: state.investmentFunds.get('list'),
        immLiquidations: state.liquidations,
        immMovements: state.movements,
        immAccounts: state.accounts,
        immMorningStarInvestmentData: state.morningStarInvestmentData,
        immOffers: state.offers,
        immProfile: state.profile,
        immSavings: state.globalPosition.getIn(['savings', 'allSavings']),
        originCountry: state.profile.get('originCountry'),
    }),
    {
        getMorningStarInvestmentData: morningStarActions.getMorningStarInvestmentData,
        requestLiquidations: liquidationsActions.requestLiquidations,
        resetLiquidationsFailure: liquidationsActions.resetLiquidationsFailure,
        requestLiquidationPeriods: liquidationsActions.requestLiquidationPeriods,
        requestMovements: movementsActions.requestMovements,
        requestInterveners: depositsActions.requestDepositInterveners,
        requestDeposits: depositsActions.requestDeposits,
        requestOffers: offersActions.fetchOffersSelected,
        setRenewalOrTransferToken: contractsActions.setRenewalOrTransferToken,
        setRenewalDepositId: contractsActions.setRenewalDepositId,
        requestHideDepositOfferPost: depositsActions.requestHideDepositOfferPost,
        resetHideDepositOfferPost: depositsActions.resetHideDepositOfferPost,
    }
)(ImpositionView);
